export default __webpack_public_path__ + "static/media/torbjorn-ult.aed62c22.mp3";